export default __webpack_public_path__ + "static/media/tag-orange.a97f9f91.svg";